export default __webpack_public_path__ + "static/media/john-d-rockefellar-jr.41cbc519.png";